import { encode as base64_encode } from "base-64";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import utf8 from "utf8";
import moment from "moment";
import { getCached, setCached, invalidateCache } from "./cacheStore";

class DriversStore {
  drivers = [];
  getDrivers = [];
  getDriverName = []; //using company id
  vehicles = [];
  driverSearchData = [];
  total = 0;
  loading = false;
  excelLoadig = false;
  photoFromDb = {};
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      drivers: observable,
      total: observable,
      loading: observable,
      getDriverName: observable,
      excelLoadig: observable,
      vehicles: observable,
      photoFromDb: observable,
      driverSearchData: observable,
      loadData: action,
      addData: action,
      getDriverData: action,
      getDriverId: action,
      deleteRecord: action,
      getDriversByCompanyId: action,
      sampleExcel: action,
      toGetDriverName: action,
      exportExcel: action,
      addDriverByExcel: action,
      getDriverFunc: action,
      getSearchedDriver: action,
      getVehicles: action,
      setPhotoFromDb: action,
      addDeviceByExcel: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit, searchField, isadmin,userId }) {
   

    var postData = {
      searchField: searchField,
      companyId: companyId,
      isadmin: isadmin,
      deviceGrpOffSet: 0,
      deviceGrpSize: 10,
      limit: limit,
      offset: offset,
      userId:userId
    };

    const cacheKey = `driverList:${offset}:${limit}:${searchField}:${companyId}:${isadmin}`;
    const cached = getCached(cacheKey);
    
        if (cached) {
          this.drivers = cached.drivers;
          this.total = cached.total;
          return;
        }
     this.loading = true;    

    const base64Input = await utf8.encode(JSON.stringify(postData));
    const base2 = JSON.stringify(base64_encode(base64Input));

    var queryParams = {
      searchField: searchField,
      companyId: companyId,

      deviceGrpOffSet: 0,
      deviceGrpSize: 10,
      limit: limit,
      offset: offset,
      userId:userId,
      isadmin:isadmin
    };
    //const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=driver&a=getdriverList", "postData=" + base2);

    var response = await postApi.getClient("").get(config.NodeUrl + "/driver/getDriverList", { params: queryParams });

    // var response = await postApi.getClient("").get("http://localhost:3001/driver/getDriverList", { params: queryParams, });

    const drivers = response?.data?.drivers;
    const total = parseInt(response?.data?.TotalCount);

    setCached(cacheKey, { drivers, total });

    this.drivers = drivers;
    this.total = total;
    this.loading = false;
  }

  async addData(driver) {
    var postData = { tokenId: "80bovn8u800tg1aq9bvr73kbhh", driver };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    const base64Input = await utf8.encode(JSON.stringify(postData));
    const base2 = JSON.stringify(base64_encode(base64Input));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=driver&a=update", "postData=" + base2);

    var response = await postApi.getClient("").post(config.NodeUrl + "/driver/create", driver);
    invalidateCache('driverList');
    //var response = await postApi.getClient("").post("http://localhost:3066/driver/create",  driver );
    return response.data;
  }
  async setPhotoFromDb(photo) {
    this.photoFromDb = { fileList: photo };
  }

  // async getDriverData(driverId) {
  //   var postData = { driverId: driverId, limit: 1, offset: 0 };

  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=driver&a=getdriverList", "postData=" + base64Input);

  //   const singleRow = response?.data?.data?.drivers[0];
  //   if (singleRow.photo) {
  //     const fileList = [
  //       {
  //         name: singleRow.photo,
  //         status: "success",
  //         url: config.fleetURL + "/images/drivers/" + singleRow.photo,
  //       },
  //     ];

  //     this.setPhotoFromDb(fileList);
  //   }
  //   return singleRow;
  // }

  async getDriverData(driverId) {
    var postData = { driverId: driverId, limit: 1, offset: 0 };

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=driver&a=getdriverList", "postData=" + base64Input);

    // const singleRow = response?.data?.data?.drivers[0];
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/driver/getDriverList", {
        params: postData,
      });
    const singleRow = response?.data?.drivers[0];
    if (singleRow.photo) {
      const fileList = [
        {
          name: singleRow.photo,
          status: "success",
          url: config.fleetURL + "/images/drivers/" + singleRow.photo,
        },
      ];

      this.setPhotoFromDb(fileList);
    }
    return singleRow;
  }

  async getDriverId(driverInfo) {
    var postData = driverInfo;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=driver&a=update", "postData=" + base64Input);
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/driver/getDriverList", {
        params: postData,
      });

    return response.data.data.driverId;
  }

  async deleteRecord({ driverId, userId }) {
    const postData = {
      tokenId: "80bovn8u800tg1aq9bvr73kbhh",
      driver: { userId: userId, driverId: driverId },
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=driver&a=delete", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .delete(config.NodeUrl + `/driver/delete-driver/${driverId}`, userId);
    
      invalidateCache('driverList');
      
    return response;
  }

  // get Driver Data using Company Id
  async getDriversByCompanyId(companyId) {
    var postData = {
      tokenId: "",
      companyId: companyId,
      isadmin: -1,
      deviceGrpOffSet: 0,
      deviceGrpSize: 10,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=getdata", "postData=" + base64Input);

    let allDrivers = [{ driverId: 0, name: "ALL" }];
    allDrivers = [...allDrivers, ...response?.data?.data.company[0].drivers];
    this.getDrivers = allDrivers;

    return response?.data?.data.company[0].drivers;
  }

  //To get driver dropdown
  async toGetDriverName(companyId) {
    // console.log(companyId,"dwee")
    var postData = {
      tokenId: "",
      companyId: companyId,
      offset: 0,
      limit: 500,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=driver&a=getdriverList", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/driver/getDriverList", {
        params: postData,
      });
    this.getDriverName = response?.data?.drivers;

    return response?.data?.drivers;
  }

  async sampleExcel() {
    // window.location.href =
    //   "http://192.168.1.100:8088/awtl_react/public/fleet/appRes/excel/driver.xlsx";

    window.location.href = config.fleetURL + "/appRes/excel/driver.xlsx";
  }
  // async exportExcel(getData) {
  //   window.location.href =
  //     baseURL +
  //     "index.php?c=driver&a=driverExportexcel&cid=" +
  //     getData.companyId +
  //     "&searchField=" +
  //     getData.searchField +
  //     "&colList=" +
  //     getData.colList;
  // }

  async exportExcel(postData) {
    try {
      var data = {
        tokenId: "",
        companyId: postData.companyId,
        searchField: postData.searchField,
        colList: postData.colList,
      };
      const response = await postApi.getClient("").post(
        config.NodeUrl + "/driver/export-driver",
        { data },
        {
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Driver_Excel.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async addDriverByExcel(excelFile) {
    this.excelLoadig = true;
    var postData = excelFile;

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=driver&a=driverexcel", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/driver/importDriverData", excelFile);
    this.excelLoadig = false;
    return response.data;
  }

  async getDriverFunc(data) {
    var postData = data;

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=driver&a=getDriver", "postData=" + base64Input);
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/driver/getDriverData", {
        params: postData,
      });
    return response?.data?.data;
  }

  async getSearchedDriver(data) {
    var postData = data;

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=trip&a=getDriver", "postData=" + base64Input);
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/vehicle/getDriver", {
        params: postData,
      });
    let vehicleData = response?.data?.data;

    this.driverSearchData = await this.handleVehicleImage(vehicleData);

    return response?.data?.data;
  }

  async handleVehicleImage(data) {
    let liveTrackingData = data;
    Object.keys(liveTrackingData).map((e, i) => {
      let r = liveTrackingData[i];

      //  var diff = new Date(r.currtime) - new Date(r.updatedate);
      const diff = moment(r.currtime).diff(r.updatedate, "minutes");
      var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
      let defaultImage = "car-icon-blue.png";
      if (diff >= 90) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
        liveTrackingData[i].rowBackground = "gray";
        liveTrackingData[i].currentStatus = "No Data";
        defaultImage = "default-gray.png";
      } else if (r.acc == 1 && r.speed == 0) {
        //idle)
        liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
        liveTrackingData[i].rowBackground = "yellow";
        liveTrackingData[i].currentStatus = "Idle";
        defaultImage = "default-yellow.png";
      } else if (r.acc == 0) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
        liveTrackingData[i].rowBackground = "red";
        liveTrackingData[i].currentStatus = "Stopped";
        defaultImage = "default-red.png";
      } else if (r.acc == null || (r.acc == 1 && r.speed > 0)) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
        liveTrackingData[i].rowBackground = "green";
        liveTrackingData[i].currentStatus = "Running";
        defaultImage = "default-green.png";
      }

      liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

      try {
        require("../assets/images/detailtracking/" +
          liveTrackingData[i].listImage);
      } catch (err) {
        liveTrackingData[i].listImage = defaultImage;
      }

      try {
        require("../assets/images/livetracking/" +
          liveTrackingData[i].mapImage);
      } catch (err) {
        liveTrackingData[i].mapImage = defaultImage; //"car-icon-blue.png";
      }
    });
    return liveTrackingData;
  }
  async getVehicles(companyId) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
    this.vehicles = response.data.data;
  }

  async addDeviceByExcel(excelFile) {
    this.excelLoadig = true;
    var postData = excelFile;

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=device&a=deviceexcel", "postData=" + base64Input);
    this.excelLoadig = false;
    return response.data;
  }

  async updateStatus(data) {
    var postData = data;
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=driver&a=updateActive", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/driver/updateActive-driver", postData);
    return response.data;
  }

  async sendlogoutCommand({ vehicleNo }) {
    var postData = { tokenId: "", vehicleNo };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/driver/sendlogoutCommand", postData);
    // .post("http://localhost:3001/driver/sendlogoutCommand", postData);
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=user&a=forcelogout", "postData=" + base64Input);
    return response.data;
  }
  async logoutDriver({ driverId }) {
    var postData = { tokenId: "", driverId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/driver/logout-driver", postData);
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=user&a=forcelogout", "postData=" + base64Input);
    return response.data;
  }
}

export default DriversStore;
